import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { NavBarTab } from "./nav-bar-tab";
import { useRoles } from "../../useRoles";

export const NavBarTabs = () => {
  const { isAuthenticated } = useAuth0();
  const { isAdmin, isPartner } = useRoles();

  return (
    <div className="nav-bar__tabs">
      <NavBarTab path="/priser" label="Priser" />
      {isAuthenticated && (
        <>
          {isAdmin && <NavBarTab path="/admin" label="Admin" />}
          <NavBarTab path="/dashbord" label="Dashbord" />
          <NavBarTab path="/konto" label="Konto" />
          {(isPartner || isAdmin) && (
            <NavBarTab path="/partner" label="Partner" />
          )}
        </>
      )}
    </div>
  );
};
